import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { GetOrderedMasterTabMenuExecute, getLocalStorageVariables, getSettingStatus, getThemeSettingsVariables, handleTokenExpiry, isJsonString } from "../../../common/Global/commonFunctions";
import Topbar from "../../../common/Topbar";
import MasterMenuTabs from "../Common/topmenu";
import Sidebar from "../../../common/SidebarCollapse";
import * as Constants from '../../../common/Global/constants';
import OverallAssignmentComponent from '../../../common/OverallAssignment';

let themeSettings = getThemeSettingsVariables();
let userDetails = getLocalStorageVariables();

export default class OverallAssignment extends React.PureComponent {
    constructor(props) {
		super(props);
		this.state = {
            assignmentId: this.props.match.params.id,
            showLoader: false,
            componentDidMountFlag: false,
            menus: [],
            assignmentDetails:{},
            auditType:"",
            isSampleCheckedScreen:false,
            isAuditeeScreen:false,
            isTimelineScreen:false
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount() {
		this.getInitData();
	}

    getInitData = () => {
        this.setState({
            showLoader: true,
        });
        Promise.all([
            fetch(Constants.GetUserMenu, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                }),
            }),
            fetch(Constants.GetAssignmentsDetails, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.state.assignmentId,
                }),
            }),
        ])
        .then(([menuRes, assignmentRes]) => {
            return Promise.all([menuRes.json(), assignmentRes.json()]);
        })
        .then(([menuRes, assignmentRes]) => {
            let assignmentDetails = {}, menusTemp = {};
            let auditType = "";
            let allSettings = [];
            let isSampleCheckedScreen = false;
            let isAuditeeScreen = false;
            let isTimelineScreen = false;
            if(handleTokenExpiry(menuRes.responseCode)) return;
            else if (menuRes.responseCode === Constants.CODE_SUCCESS) {
                menusTemp = menuRes.data.menus;
                allSettings = menuRes.data.allSettings;
            }

            if(handleTokenExpiry(assignmentRes.responseCode)) return;
            else if (assignmentRes.responseCode === Constants.CODE_SUCCESS) {
                assignmentDetails = assignmentRes.data.assignmentDetails;
                auditType = assignmentDetails.auditType;
            }
            const { departmentId, assignmentTypeId, rootTemplateId } = assignmentDetails;
            isSampleCheckedScreen = getSettingStatus(allSettings, Constants.DOCLIST, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
            isAuditeeScreen = getSettingStatus(allSettings, Constants.AUDITEE, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
            isTimelineScreen = getSettingStatus(allSettings, Constants.TIMELINE, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
            let menusTemp2 = GetOrderedMasterTabMenuExecute(menusTemp,assignmentDetails.observationTemplateId,isSampleCheckedScreen,assignmentDetails.assignmentLevelTemplateId);
            
            this.setState({
                showLoader: false,
                componentDidMountFlag: true,
                menus: menusTemp2,
                assignmentDetails:assignmentDetails,
                auditType:auditType,
                isSampleCheckedScreen:isSampleCheckedScreen,
                isAuditeeScreen:isAuditeeScreen,
                isTimelineScreen:isTimelineScreen
            });
        });
    }

    render () {
        return (
            <Router>
                <main className="main-dashboard">
					<section className="dashboard-bg">
						<Sidebar />
                        <div className="dashboard-right-bg-collpase">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                <MasterMenuTabs 
                                    masterMenus={this.state.menus}
                                    themeSettings={themeSettings}
                                    assignmentId={this.state.assignmentId}
                                    auditType={this.state.auditType}
                                    isSampleCheckedScreen={this.state.isSampleCheckedScreen}
                                    isAuditeeScreen={this.state.isAuditeeScreen}
                                    isTimelineScreen={this.state.isTimelineScreen}
                                />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                {
                                    this.state.componentDidMountFlag &&
                                    <OverallAssignmentComponent
                                        assignmentId={this.state.assignmentId}
                                        isEditable={true}
                                        getDatalistApi={Constants.GetAssignmentLevelMasterData}
                                        saveDatalistApi={Constants.SaveAssignmentLevelTemplateValues}
                                    />
                                }
                            </div>
                        </div>
                    </section>
                </main>
            </Router>
        )
    }
}
